import { AnyAction } from 'redux';

export const OPEN_SIGN_UP = 'AUTH/OPEN_SIGN_UP';
export const OPEN_LOGIN = 'AUTH/OPEN_LOGIN';
export const CLOSE_MODAL = 'AUTH/CLOSE_MODAL';
export const OPEN_CHOOSER = 'AUTH/OPEN_CHOOSER';
export const RESET_TO_CHOOSER = 'AUTH/RESET_TO_CHOOSER';
export const OPEN_OTP_SIGN_IN = 'AUTH/OPEN_OTP_SIGN_IN';
export const OPEN_OTP_SIGN_UP = 'AUTH/OPEN_OTP_SIGN_UP';
export const OPEN_ENTER_PASSWORD = 'AUTH/OPEN_ENTER_PASSWORD';
export const OPEN_ENTER_NAME = 'AUTH/OPEN_ENTER_NAME';
export const CONFIRM_SIGNUP = 'AUTH/CONFIRM_SIGNUP';
export const SET_SIGNUP_EMAIL = 'AUTH/SET_SIGNUP_EMAIL';
export const OPEN_PASSWORD_RECOVERY = 'AUTH/OPEN_PASSWORD_RECOVERY';
export const SET_CHECK_MAIL = 'AUTH/SET_CHECK_MAIL';
export const OPEN_CHECK_MAIL = 'AUTH/OPEN_CHECK_MAIL';
export const OPEN_NEW_PASSWORD = 'AUTH/OPEN_NEW_PASSWORD';
export const OPEN_PROFILE_PAGE = 'AUTH/OPEN_PROFILE_PAGE';

// export const openProfilePageAction = (): AnyAction => ({
//   type: OPEN_PROFILE_PAGE,
// });

export const openNewPasswordAction = (): AnyAction => ({
  type: OPEN_NEW_PASSWORD,
})

export const openCheckMailAction = (): AnyAction => ({
  type: OPEN_CHECK_MAIL,
});

export const openPasswordRecoveryAction = (): AnyAction => ({
  type: OPEN_PASSWORD_RECOVERY,
});

export const confirmSignUpAction = (): AnyAction => ({
  type: CONFIRM_SIGNUP,
});

export const setSignUpEmailAction = (email: string): AnyAction => ({
  type: SET_SIGNUP_EMAIL,
  payload: email,
});

export const setCheckMailAction = (code: string): AnyAction => ({
  type: SET_CHECK_MAIL,
  payload: code,
});

export const openEnterPasswordAction = (): AnyAction => ({
  type: OPEN_ENTER_PASSWORD,
});

export const openOtpSignInAction = (): AnyAction => ({
  type: OPEN_OTP_SIGN_IN,
});

export const openOtpSignUpAction = (): AnyAction => ({
  type: OPEN_OTP_SIGN_UP,
});

export const resetToChooserAction = (): AnyAction => ({
  type: RESET_TO_CHOOSER,
});

export const openSignUpAction = (): AnyAction => ({
  type: OPEN_SIGN_UP,
});

export const openLoginAction = (): AnyAction => ({
  type: OPEN_LOGIN,
});

export const closeModalAction = (): AnyAction => ({
  type: CLOSE_MODAL,
});

export const openChooserAction = (): AnyAction => ({
  type: OPEN_CHOOSER,
});
